import type { ColorOption } from '~/types/Colors'

export enum SubmissionGroupStatus {
  OPEN = 'open',
  CLOSED = 'closed',
  PAUSED = 'paused',
}

export interface SubmissionGroup {
  id: string
  name: string
  color: ColorOption
  description: string
  status: SubmissionGroupStatus
}

export interface SubmissionGroupWithStats extends SubmissionGroup {
  submissionCount: number
  gradedSubmissionCount: number
  ungradedSubmissionCount: number
  gradingErrorCount: number
  averageScore: number | null
  maxPoints: number | null
}
